(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-box-slider"] && !Shopify.designMode) return;
  try {
    
  // Slider is started from layout/theme.liquid (lazy-loaded)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["offer-box"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  var sections = document.querySelectorAll("[id^='ct-section-']");

  sections.forEach(function (el) {
    var sectionId = el.id.replace("ct-section-", "");
    var endDate = el.getAttribute("data-end-date");
    var endTime = el.getAttribute("data-end-time");

    // Hide if fields are empty
    if (!endDate || !endTime) return;

    var endDateTime = new Date(endDate + "T" + endTime).getTime();

    // Hide if already expired
    if (new Date().getTime() >= endDateTime) return;

    // Show the timer — only visible now that we confirmed it's valid and not expired
    el.style.display = "flex";

    function pad(n) {
      return n < 10 ? "0" + n : n;
    }

    function tick() {
      var now = new Date().getTime();
      var distance = endDateTime - now;

      // Hide entire timer div when expired
      if (distance <= 0) {
        el.style.display = "none";
        return;
      }

      var days    = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours   = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      var daysEl    = document.getElementById("ct-days-" + sectionId);
      var hoursEl   = document.getElementById("ct-hours-" + sectionId);
      var minutesEl = document.getElementById("ct-minutes-" + sectionId);
      var secondsEl = document.getElementById("ct-seconds-" + sectionId);

      if (daysEl) daysEl.innerText = pad(days);
      if (hoursEl) hoursEl.innerText = pad(hours);
      if (minutesEl) minutesEl.innerText = pad(minutes);
      if (secondsEl) secondsEl.innerText = pad(seconds);
    }

    tick();
    setInterval(tick, 1000);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  var section = document.querySelector('.sb_faq');
  if (!section) return;

  var items = section.querySelectorAll('.faq-item');

  items.forEach(function (item) {
    var btn = item.querySelector('.faq-question');
    var answer = item.querySelector('.faq-answer');

    btn.addEventListener('click', function () {
      var isOpen = item.classList.contains('open');

      // Close all
      items.forEach(function (el) {
        el.classList.remove('open');
        el.querySelector('.faq-answer').style.maxHeight = null;
      });

      // Open clicked if it was closed
      if (!isOpen) {
        item.classList.add('open');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-sticky-content"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const cardLeft = document.querySelector('.card-left img');
    const cardRight = document.querySelector('.card-right img');

    window.addEventListener('scroll', () => {
      const scrollY = window.scrollY;
      const section = document.querySelector('.cards_section');

      if (!section) return;

      const sectionTop = section.getBoundingClientRect().top + scrollY;
      const sectionHeight = section.offsetHeight;

      const progress = Math.min(Math.max((scrollY - sectionTop) / sectionHeight, 0), 1);

      const rotateLeft = -8 + 8 * progress;
      const rotateRight = 8 - 8 * progress;

      if (cardLeft) cardLeft.style.transform = `rotate(${rotateLeft}deg)`;
      if (cardRight) cardRight.style.transform = `rotate(${rotateRight}deg)`;
    });
  });

  } catch(e) { console.error(e); }
})();
})();
